/* fs-pdp-fbt — toggle selection + live bundle total + real multi-add-to-cart.
   Live mode (data-fbt-live): cards carry data-variant-id + data-price (cents). */
(function () {
  'use strict';
  var fbt = document.querySelector('[data-fbt]');
  if (!fbt) return;
  var live = fbt.hasAttribute('data-fbt-live');

  var cards = Array.prototype.slice.call(fbt.querySelectorAll('[data-fbt-card]'));
  var totalEl = fbt.querySelector('[data-fbt-total]');
  var totalWasEl = fbt.querySelector('.fs-pdp-fbt__total .fs-pdp-fbt__was');
  var totalSaveEl = fbt.querySelector('.fs-pdp-fbt__total .fs-pdp-fbt__save');
  var countLabel = fbt.querySelector('[data-fbt-count-label]');
  var addBtn = fbt.querySelector('[data-fbt-add]');

  // currency symbol from first card's rendered price. Read the __price-now span
  // (the single active price) — NOT the whole __price block, which now also holds
  // the struck compare-at price, so its text is "$X$Y" → the symbol came out "$$".
  var sym = '$';
  var firstPrice = fbt.querySelector('.fs-pdp-fbt__price-now') || fbt.querySelector('.fs-pdp-fbt__price');
  if (firstPrice) { var m = (firstPrice.textContent.match(/^[^\d]+/) || [''])[0].trim(); if (m) sym = m; }

  function selectedCards() {
    return cards.filter(function (c) { return c.classList.contains('is-selected') && !c.hasAttribute('data-unavailable'); });
  }

  function money(cents) { return sym + (cents / 100).toFixed(2); }

  function recompute() {
    if (!live || !totalEl) return;
    var sel = selectedCards();
    var cents = sel.reduce(function (sum, c) { return sum + (parseInt(c.getAttribute('data-price'), 10) || 0); }, 0);
    var compareCents = sel.reduce(function (sum, c) {
      var cmp = parseInt(c.getAttribute('data-compare'), 10);
      var pr = parseInt(c.getAttribute('data-price'), 10) || 0;
      return sum + (cmp && cmp > pr ? cmp : pr);
    }, 0);
    totalEl.textContent = money(cents);
    // Struck compare-at total + Save % — computed live from the selected cards,
    // only shown when there's a real saving (else the "Save 40%" default was bogus).
    var saving = compareCents - cents;
    if (totalWasEl) {
      if (saving > 0) { totalWasEl.textContent = money(compareCents); totalWasEl.style.display = ''; }
      else { totalWasEl.style.display = 'none'; }
    }
    if (totalSaveEl) {
      if (saving > 0 && compareCents > 0) {
        totalSaveEl.textContent = 'Save ' + Math.round(saving * 100 / compareCents) + '%';
        totalSaveEl.style.display = '';
      } else { totalSaveEl.style.display = 'none'; }
    }
    if (countLabel) countLabel.textContent = 'Bundle Total (' + sel.length + ' item' + (sel.length === 1 ? '' : 's') + ' selected)';
    if (addBtn) addBtn.disabled = sel.length === 0;
  }

  cards.forEach(function (card) {
    if (card.hasAttribute('data-unavailable')) return;
    card.addEventListener('click', function () {
      card.classList.toggle('is-selected');
      recompute();
    });
  });

  // multi add-to-cart
  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (!live) return; // fallback mode: no real cart
      var sel = selectedCards();
      if (!sel.length) return;
      var items = sel.map(function (c) {
        return { id: parseInt(c.getAttribute('data-variant-id'), 10), quantity: 1 };
      });
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      // request cart-drawer section HTML back so we can refresh the drawer in place (no redirect)
      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer) { body.sections = 'cart-drawer'; body.sections_url = window.location.pathname; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart add failed');
        return r.json();
      }).then(function (res) {
        addBtn.textContent = original; addBtn.disabled = false;
        // refresh + open Ella cart drawer (no full-page redirect)
        if (drawer && res.sections && res.sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: res.sections });
        } else if (drawer && typeof drawer.open === 'function') {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          drawer.open();
        } else {
          // no drawer available → fall back to cart page
          window.location.href = '/cart';
        }
      }).catch(function () {
        addBtn.textContent = original; addBtn.disabled = false;
      });
    });
  }

  recompute();
})();
